import { useState, useEffect } from 'react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
const TimePickerFieldMain = (props) => {
  const { isMobile } = useMobileSettings();
  const [component, setComponent] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      try {
        if (isMobile) {
          const module = await import('../MobileComponents/TimePickerFieldMob');
          setComponent(() => module.default);
        } else {
          const module = await import('../WebComponents/TimePickerFieldWeb');
          setComponent(() => module.default);
        }
      } catch (error) {
        console.error('Error loading component:', error);
      }
    };

    loadComponent();
  }, [isMobile]);

  const LoadedComponent = component;
  return component ? <LoadedComponent {...props} /> : <></>;
};

export default TimePickerFieldMain;
